module.exports = __webpack_public_path__ + "img/whatsapp.a5c2d227.svg";